import { HttpClient } from '../../protocols/http/httpClient'
import {
  ICreateCustomRole,
  CreateRoleParams,
  CustomRole
} from '../../../domain/usecases/Roles'
import { throwIfHttpError } from '../../../validation/httpError'

export class RemoteCreateCustomRole implements ICreateCustomRole {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async create(params: CreateRoleParams): Promise<CustomRole> {
    const httpResponse = await this.httpClient.post?.({
      url: `${this.url}/roles/custom`,
      data: params
    })

    return throwIfHttpError(httpResponse, 'Erro ao criar função')
  }
}
